import { render, staticRenderFns } from "./FieldBadgeTest.vue?vue&type=template&id=742f1aa6&scoped=true"
import script from "./FieldBadgeTest.vue?vue&type=script&lang=js"
export * from "./FieldBadgeTest.vue?vue&type=script&lang=js"
import style0 from "./FieldBadgeTest.vue?vue&type=style&index=0&id=742f1aa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "742f1aa6",
  null
  
)

export default component.exports